import { useColorScheme } from '@mui/material/styles';
import { useCallback } from 'react';
export const useIsLight = ()=>{
    const { mode } = useColorScheme();
    return mode === 'light';
};
export const useIsDark = ()=>{
    const { mode } = useColorScheme();
    return mode === 'dark';
};
export const useToggleThemeMode = ()=>{
    const { mode, setMode } = useColorScheme();
    return useCallback(()=>{
        setMode(mode === 'light' ? 'dark' : 'light');
    }, [
        mode,
        setMode
    ]);
};
